import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { errorMsg } from "../../Toastify";
import { GetProductLowQuantityList } from "../../../Repository/Api";

const ProductQuantity = () => {
  const { first_name, desingation, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token

  useEffect(() => {
    getProductlist();
  }, []);

  const [product, setProduct] = useState([]);

  const getProductlist = async () => {
    const response = await GetProductLowQuantityList(token);
    if (response && response.statusCode === 200) {
      setProduct(response?.data?.product);
    } else {
      errorMsg(response.message);
    }
  };

  return (
    <>
      <div className="graphbox">
        <div className="scroll-table">
          <table className="table table-hover">
            <thead>
              <tr>
                <th scope="col">S.No</th>
                <th scope="col">Product Name</th>
                <th scope="col">Quantity</th>
                <th scope="col">Min Quantity Available</th>
              </tr>
            </thead>
            <tbody>
              {product.length > 0 ? (
                product &&
                product.map((productitem, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{productitem?.name}</td>
                    <td>{productitem?.quantity}</td>
                    <td>{productitem?.minimum_quantity_available}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td></td>
                  <td></td>
                  <td>
                    <div> No Data Found </div>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default ProductQuantity;
